msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: gl\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-12-22 05:44\n"
"Last-Translator: \n"
"Language-Team: Galician\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: gl\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:136
msgid "Locked"
msgstr "Bloqueada"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:142
msgid "Posts: {0}"
msgstr "Publicacións: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:147
msgid "Last posted: {0}"
msgstr "Última publicación: {0}"

#: src/components/account-block.jsx:162
#: src/components/account-info.jsx:636
msgid "Automated"
msgstr "Automatizada"

#: src/components/account-block.jsx:169
#: src/components/account-info.jsx:641
#: src/components/status.jsx:514
msgid "Group"
msgstr "Grupo"

#: src/components/account-block.jsx:179
msgid "Mutual"
msgstr "Recíproco"

#: src/components/account-block.jsx:183
#: src/components/account-info.jsx:1682
msgid "Requested"
msgstr "Solicitado"

#: src/components/account-block.jsx:187
#: src/components/account-info.jsx:1673
msgid "Following"
msgstr "Seguindo"

#: src/components/account-block.jsx:191
#: src/components/account-info.jsx:1064
msgid "Follows you"
msgstr "Séguete"

#: src/components/account-block.jsx:199
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# seguidora} other {# seguidoras}}"

#: src/components/account-block.jsx:208
#: src/components/account-info.jsx:682
msgid "Verified"
msgstr "Verificada"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:223
#: src/components/account-info.jsx:782
msgid "Joined <0>{0}</0>"
msgstr "Creada <0>{0}</0>"

#: src/components/account-info.jsx:58
msgid "Forever"
msgstr "Permanente"

#: src/components/account-info.jsx:379
msgid "Unable to load account."
msgstr "Non se puido cargar a conta."

#: src/components/account-info.jsx:387
msgid "Go to account page"
msgstr "Ir á páxina da conta"

#: src/components/account-info.jsx:415
#: src/components/account-info.jsx:704
#: src/components/account-info.jsx:734
msgid "Followers"
msgstr "Seguidoras"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:418
#: src/components/account-info.jsx:744
#: src/components/account-info.jsx:761
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:421
#: src/components/account-info.jsx:778
#: src/pages/account-statuses.jsx:483
#: src/pages/search.jsx:328
#: src/pages/search.jsx:475
msgid "Posts"
msgstr "Publicacións"

#: src/components/account-info.jsx:429
#: src/components/account-info.jsx:1120
#: src/components/compose.jsx:2592
#: src/components/media-alt-modal.jsx:46
#: src/components/media-modal.jsx:358
#: src/components/status.jsx:1737
#: src/components/status.jsx:1754
#: src/components/status.jsx:1878
#: src/components/status.jsx:2490
#: src/components/status.jsx:2493
#: src/pages/account-statuses.jsx:527
#: src/pages/accounts.jsx:110
#: src/pages/hashtag.jsx:200
#: src/pages/list.jsx:158
#: src/pages/public.jsx:115
#: src/pages/status.jsx:1214
#: src/pages/trending.jsx:472
msgid "More"
msgstr "Máis"

#: src/components/account-info.jsx:441
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> informou de que agora a súa conta é:"

#: src/components/account-info.jsx:586
#: src/components/account-info.jsx:1278
msgid "Handle copied"
msgstr "Copiouse o identificador"

#: src/components/account-info.jsx:589
#: src/components/account-info.jsx:1281
msgid "Unable to copy handle"
msgstr "Non se puido copiar o identificador"

#: src/components/account-info.jsx:595
#: src/components/account-info.jsx:1287
msgid "Copy handle"
msgstr "Copiar identificador"

#: src/components/account-info.jsx:601
msgid "Go to original profile page"
msgstr "Ir á páxina orixinal do perfil"

#: src/components/account-info.jsx:608
msgid "View profile image"
msgstr "Ver imaxe do perfil"

#: src/components/account-info.jsx:614
msgid "View profile header"
msgstr "Ver cabeceira do perfil"

#: src/components/account-info.jsx:631
msgid "In Memoriam"
msgstr "Lembranzas"

#: src/components/account-info.jsx:711
#: src/components/account-info.jsx:752
msgid "This user has chosen to not make this information available."
msgstr "A usuaria decidiu non ofrecer esta información."

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:807
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} publicacións orixinais, {1} respostas, {2} promocións"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:823
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {A última publicación desde onte} other {A última publicación desde fai {2} días}}} other {{3, plural, one {As úlltimas {4} publicacións desde onte} other {As últimas {5} publicacións dos últimos {6} días}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:836
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Última publicación no último ano(s)} other {Últimas {1} publicacións no último ano(s)}}"

#: src/components/account-info.jsx:860
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Orixinal"

#: src/components/account-info.jsx:864
#: src/components/status.jsx:2268
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2058
#: src/pages/status.jsx:937
#: src/pages/status.jsx:1560
msgid "Replies"
msgstr "Respostas"

#: src/components/account-info.jsx:868
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2070
#: src/pages/settings.jsx:1155
msgid "Boosts"
msgstr "Promocións"

#: src/components/account-info.jsx:874
msgid "Post stats unavailable."
msgstr "Estatísticas non dispoñibles."

#: src/components/account-info.jsx:905
msgid "View post stats"
msgstr "Ver estatísticas de publicación"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-info.jsx:1068
msgid "Last post: <0>{0}</0>"
msgstr "Última publicación: <0>{0}</0>"

#: src/components/account-info.jsx:1082
msgid "Muted"
msgstr "Acalada"

#: src/components/account-info.jsx:1087
msgid "Blocked"
msgstr "Bloqueada"

#: src/components/account-info.jsx:1096
msgid "Private note"
msgstr "Nota privada"

#: src/components/account-info.jsx:1153
msgid "Mention <0>@{username}</0>"
msgstr "Mencionar a <0>@{username}</0>"

#: src/components/account-info.jsx:1165
msgid "Translate bio"
msgstr "Traducir bio"

#: src/components/account-info.jsx:1176
msgid "Edit private note"
msgstr "Editar nota privada"

#: src/components/account-info.jsx:1176
msgid "Add private note"
msgstr "Engadir nota privada"

#: src/components/account-info.jsx:1196
msgid "Notifications enabled for @{username}'s posts."
msgstr "Activadas as notificacións para as publicacións de @{username}."

#: src/components/account-info.jsx:1197
msgid " Notifications disabled for @{username}'s posts."
msgstr " Desactivadas as notificacións para as publicacións de @{username}."

#: src/components/account-info.jsx:1209
msgid "Disable notifications"
msgstr "Desactivar notificacións"

#: src/components/account-info.jsx:1210
msgid "Enable notifications"
msgstr "Activar notificacións"

#: src/components/account-info.jsx:1227
msgid "Boosts from @{username} enabled."
msgstr "Activadas as promocións de @{username}."

#: src/components/account-info.jsx:1228
msgid "Boosts from @{username} disabled."
msgstr "Desactivadas as promocións de @{username}."

#: src/components/account-info.jsx:1239
msgid "Disable boosts"
msgstr "Desactivar promocións"

#: src/components/account-info.jsx:1239
msgid "Enable boosts"
msgstr "Activar promocións"

#: src/components/account-info.jsx:1255
#: src/components/account-info.jsx:1265
#: src/components/account-info.jsx:1868
msgid "Add/Remove from Lists"
msgstr "Engadir/Retirar das Listas"

#: src/components/account-info.jsx:1304
#: src/components/status.jsx:1177
msgid "Link copied"
msgstr "Copiouse a ligazón"

#: src/components/account-info.jsx:1307
#: src/components/status.jsx:1180
msgid "Unable to copy link"
msgstr "Non se puido copiar a ligazón"

#: src/components/account-info.jsx:1313
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1186
#: src/components/status.jsx:3269
msgid "Copy"
msgstr "Copiar"

#: src/components/account-info.jsx:1328
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1202
msgid "Sharing doesn't seem to work."
msgstr "Semella que non se pode compartir."

#: src/components/account-info.jsx:1334
#: src/components/status.jsx:1208
msgid "Share…"
msgstr "Compartir…"

#: src/components/account-info.jsx:1354
msgid "Unmuted @{username}"
msgstr "Reactivouse a @{username}"

#: src/components/account-info.jsx:1366
msgid "Unmute <0>@{username}</0>"
msgstr "Reactivar a <0>@{username}</0>"

#: src/components/account-info.jsx:1382
msgid "Mute <0>@{username}</0>…"
msgstr "Acalar a <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/account-info.jsx:1414
msgid "Muted @{username} for {0}"
msgstr "Silenciaches a @{username} durante {0}"

#: src/components/account-info.jsx:1426
msgid "Unable to mute @{username}"
msgstr "Non se puido silenciar a @{username}"

#: src/components/account-info.jsx:1447
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Quitar a <0>@{username}</0> das túas seguidoras?"

#: src/components/account-info.jsx:1467
msgid "@{username} removed from followers"
msgstr "Retirouse a @{username} das seguidoras"

#: src/components/account-info.jsx:1479
msgid "Remove follower…"
msgstr "Retirar seguidora…"

#: src/components/account-info.jsx:1490
msgid "Block <0>@{username}</0>?"
msgstr "Bloquear a <0>@{username}</0>?"

#: src/components/account-info.jsx:1514
msgid "Unblocked @{username}"
msgstr "Desbloqueouse a @{username}"

#: src/components/account-info.jsx:1522
msgid "Blocked @{username}"
msgstr "Bloqueouse a @{username}"

#: src/components/account-info.jsx:1530
msgid "Unable to unblock @{username}"
msgstr "Non se puido desbloquear a @{username}"

#: src/components/account-info.jsx:1532
msgid "Unable to block @{username}"
msgstr "Non se puido bloquear a @{username}"

#: src/components/account-info.jsx:1542
msgid "Unblock <0>@{username}</0>"
msgstr "Desbloquear a <0>@{username}</0>"

#: src/components/account-info.jsx:1551
msgid "Block <0>@{username}</0>…"
msgstr "Bloquear a <0>@{username}</0>…"

#: src/components/account-info.jsx:1568
msgid "Report <0>@{username}</0>…"
msgstr "Denunciar a <0>@{username}</0>…"

#: src/components/account-info.jsx:1588
#: src/components/account-info.jsx:2103
msgid "Edit profile"
msgstr "Editar perfil"

#: src/components/account-info.jsx:1624
msgid "Withdraw follow request?"
msgstr "Retirar solicitude de seguimento?"

#. placeholder {1}: info.acct || info.username
#: src/components/account-info.jsx:1625
msgid "Unfollow @{1}?"
msgstr "Deixar de seguir a @{1}?"

#: src/components/account-info.jsx:1676
msgid "Unfollow…"
msgstr "Deixar de seguir…"

#: src/components/account-info.jsx:1685
msgid "Withdraw…"
msgstr "Retirar…"

#: src/components/account-info.jsx:1692
#: src/components/account-info.jsx:1696
#: src/pages/hashtag.jsx:262
msgid "Follow"
msgstr "Seguir"

#: src/components/account-info.jsx:1808
#: src/components/account-info.jsx:1863
#: src/components/account-info.jsx:1997
#: src/components/account-info.jsx:2098
#: src/components/account-sheet.jsx:38
#: src/components/compose.jsx:859
#: src/components/compose.jsx:2548
#: src/components/compose.jsx:3022
#: src/components/compose.jsx:3231
#: src/components/compose.jsx:3461
#: src/components/drafts.jsx:59
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:143
#: src/components/keyboard-shortcuts-help.jsx:40
#: src/components/list-add-edit.jsx:36
#: src/components/media-alt-modal.jsx:34
#: src/components/media-modal.jsx:322
#: src/components/notification-service.jsx:157
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2993
#: src/components/status.jsx:3233
#: src/components/status.jsx:3733
#: src/pages/accounts.jsx:37
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:276
#: src/pages/notifications.jsx:915
#: src/pages/settings.jsx:78
#: src/pages/status.jsx:1301
msgid "Close"
msgstr "Pechar"

#: src/components/account-info.jsx:1813
msgid "Translated Bio"
msgstr "Traduciuse a Bio"

#: src/components/account-info.jsx:1908
msgid "Unable to remove from list."
msgstr "Non se puido retirar da lista."

#: src/components/account-info.jsx:1909
msgid "Unable to add to list."
msgstr "Non se puido engadir á lista."

#: src/components/account-info.jsx:1928
#: src/pages/lists.jsx:105
msgid "Unable to load lists."
msgstr "Non se puideron cargar as listas."

#: src/components/account-info.jsx:1932
msgid "No lists."
msgstr "Sen listas."

#: src/components/account-info.jsx:1943
#: src/components/list-add-edit.jsx:40
#: src/pages/lists.jsx:59
msgid "New list"
msgstr "Nova lista"

#. placeholder {0}: account?.username || account?.acct
#: src/components/account-info.jsx:2002
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privada sobre <0>@{0}</0>"

#: src/components/account-info.jsx:2032
msgid "Unable to update private note."
msgstr "Non se puido actualizar a nota privada."

#: src/components/account-info.jsx:2055
#: src/components/account-info.jsx:2226
msgid "Cancel"
msgstr "Desbotar"

#: src/components/account-info.jsx:2060
msgid "Save & close"
msgstr "Gardar e pechar"

#: src/components/account-info.jsx:2154
msgid "Unable to update profile."
msgstr "Non se puido actualizar o perfil."

#: src/components/account-info.jsx:2161
#: src/components/list-add-edit.jsx:105
msgid "Name"
msgstr "Nome"

#: src/components/account-info.jsx:2174
msgid "Bio"
msgstr "Biografía"

#: src/components/account-info.jsx:2187
msgid "Extra fields"
msgstr "Campos extra"

#: src/components/account-info.jsx:2193
msgid "Label"
msgstr "Etiqueta"

#: src/components/account-info.jsx:2196
msgid "Content"
msgstr "Contido"

#: src/components/account-info.jsx:2229
#: src/components/list-add-edit.jsx:150
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:981
msgid "Save"
msgstr "Gardar"

#: src/components/account-info.jsx:2283
msgid "username"
msgstr "nome de usuaria"

#: src/components/account-info.jsx:2287
msgid "server domain name"
msgstr "dominio do servidor"

#: src/components/background-service.jsx:151
msgid "Cloak mode disabled"
msgstr "Desactivada a capa"

#: src/components/background-service.jsx:151
msgid "Cloak mode enabled"
msgstr "Capa activada"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:176
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:439
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:560
msgid "Home"
msgstr "Inicio"

#: src/components/compose-button.jsx:50
#: src/compose.jsx:38
msgid "Compose"
msgstr "Escribir"

#: src/components/compose.jsx:206
msgid "Add media"
msgstr "Engadir multimedia"

#: src/components/compose.jsx:207
msgid "Add custom emoji"
msgstr "Engadir emoji persoal"

#: src/components/compose.jsx:208
msgid "Add GIF"
msgstr "Engadir GIF"

#: src/components/compose.jsx:209
msgid "Add poll"
msgstr "Engadir enquisa"

#: src/components/compose.jsx:402
msgid "You have unsaved changes. Discard this post?"
msgstr "Tes cambios sen gardar. Desbotas esta publicación?"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:630
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {O ficheiro {1} non é compatible.} other {Os ficheiros {2} non son compatibles.}}"

#: src/components/compose.jsx:640
#: src/components/compose.jsx:658
#: src/components/compose.jsx:1674
#: src/components/compose.jsx:1760
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Só podes anexar un ficheiro.} other {Só podes anexar ata # ficheiros.}}"

#: src/components/compose.jsx:840
msgid "Pop out"
msgstr "Despregar"

#: src/components/compose.jsx:847
msgid "Minimize"
msgstr "Minimizar"

#: src/components/compose.jsx:883
msgid "Looks like you closed the parent window."
msgstr "Semella que fechaches a xanela nai."

#: src/components/compose.jsx:890
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Semella que xa tes aberto un cadro de edición na xanela nai e estase a publicar. Por favor agarda a que remate e inténtao outra vez máis tarde."

#: src/components/compose.jsx:895
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Semella que xa tes un cadro de edición aberto na xanela nai. Ao traelo a esta xanela desbotarás os cambios realizados na xanela nai. Queres continuar?"

#: src/components/compose.jsx:937
msgid "Pop in"
msgstr "Restablecer"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:947
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Respondendo á publicación de @{0} (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:957
msgid "Replying to @{0}’s post"
msgstr "Respondendo á publicación de @{0}"

#: src/components/compose.jsx:970
msgid "Editing source post"
msgstr "Editando o contido da publicación"

#: src/components/compose.jsx:1017
msgid "Poll must have at least 2 options"
msgstr "A enquisa ten que ter 2 opcións como mínimo"

#: src/components/compose.jsx:1021
msgid "Some poll choices are empty"
msgstr "Algunhas opcións da enquisa están baleiras"

#: src/components/compose.jsx:1034
msgid "Some media have no descriptions. Continue?"
msgstr "Algún do multimedia non ten descrición. Queres continuar?"

#: src/components/compose.jsx:1086
msgid "Attachment #{i} failed"
msgstr "Fallou o anexo #{i}"

#: src/components/compose.jsx:1180
#: src/components/status.jsx:2063
#: src/components/timeline.jsx:989
msgid "Content warning"
msgstr "Aviso sobre o contido"

#: src/components/compose.jsx:1196
msgid "Content warning or sensitive media"
msgstr "Aviso sobre o contido ou multimedia sensible"

#: src/components/compose.jsx:1232
#: src/components/status.jsx:93
#: src/pages/settings.jsx:306
msgid "Public"
msgstr "Pública"

#: src/components/compose.jsx:1237
#: src/components/nav-menu.jsx:338
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Local"

#: src/components/compose.jsx:1241
#: src/components/status.jsx:95
#: src/pages/settings.jsx:309
msgid "Unlisted"
msgstr "Fóra das listas"

#: src/components/compose.jsx:1244
#: src/components/status.jsx:96
#: src/pages/settings.jsx:312
msgid "Followers only"
msgstr "Só para seguidoras"

#: src/components/compose.jsx:1247
#: src/components/status.jsx:97
#: src/components/status.jsx:1941
msgid "Private mention"
msgstr "Mención privada"

#: src/components/compose.jsx:1256
msgid "Post your reply"
msgstr "Publica a resposta"

#: src/components/compose.jsx:1258
msgid "Edit your post"
msgstr "Edita a publicación"

#: src/components/compose.jsx:1259
msgid "What are you doing?"
msgstr "Que estás a facer?"

#: src/components/compose.jsx:1337
msgid "Mark media as sensitive"
msgstr "Marcar o multimedia como sensible"

#: src/components/compose.jsx:1381
#: src/components/compose.jsx:3080
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:362
msgid "Add"
msgstr "Engadir"

#: src/components/compose.jsx:1555
#: src/components/keyboard-shortcuts-help.jsx:152
#: src/components/status.jsx:929
#: src/components/status.jsx:1717
#: src/components/status.jsx:1718
#: src/components/status.jsx:2386
msgid "Reply"
msgstr "Responder"

#: src/components/compose.jsx:1557
msgid "Update"
msgstr "Actualizar"

#: src/components/compose.jsx:1558
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publicar"

#: src/components/compose.jsx:1686
msgid "Downloading GIF…"
msgstr "Descargando GIF…"

#: src/components/compose.jsx:1714
msgid "Failed to download GIF"
msgstr "Fallou a descarga da GIF"

#: src/components/compose.jsx:1879
#: src/components/compose.jsx:1956
#: src/components/nav-menu.jsx:239
msgid "More…"
msgstr "Máis…"

#: src/components/compose.jsx:2361
msgid "Uploaded"
msgstr "Cargada"

#: src/components/compose.jsx:2374
msgid "Image description"
msgstr "Descrición da imaxe"

#: src/components/compose.jsx:2375
msgid "Video description"
msgstr "Descrición do vídeo"

#: src/components/compose.jsx:2376
msgid "Audio description"
msgstr "Descrición do audio"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#: src/components/compose.jsx:2412
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Ficheiro demasiado grande. Podería haber problemas ao cargalo. Intenta reducir o tamaño de {0} a {1} ou inferior."

#. placeholder {2}: i18n.number( width, )
#. placeholder {3}: i18n.number(height)
#. placeholder {4}: i18n.number(newWidth)
#. placeholder {5}: i18n.number( newHeight, )
#: src/components/compose.jsx:2424
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {2}×{3}px to {4}×{5}px."
msgstr "Tamaño demasiado grande. Podería dar problemas ao cargala. Intenta reducir o tamaño de {2}×{3}px a {4}×{5}px."

#. placeholder {6}: prettyBytes( videoSize, )
#. placeholder {7}: prettyBytes(videoSizeLimit)
#: src/components/compose.jsx:2432
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {6} to {7} or lower."
msgstr "Ficheiro demasiado grande. Podería haber problemas ao cargalo. Intenta reducir o tamaño de {6} a {7} ou inferior."

#. placeholder {8}: i18n.number( width, )
#. placeholder {9}: i18n.number(height)
#. placeholder {10}: i18n.number(newWidth)
#. placeholder {11}: i18n.number( newHeight, )
#: src/components/compose.jsx:2444
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {8}×{9}px to {10}×{11}px."
msgstr "Tamaño demasiado grande. Podería dar problemas ao cargala. Intenta reducir o tamaño de {8}×{9}px a {10}×{11}px."

#: src/components/compose.jsx:2452
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Taxa de imaxes demasiado alta. Podería dar problemas ao cargalo."

#: src/components/compose.jsx:2512
#: src/components/compose.jsx:2762
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Retirar"

#: src/components/compose.jsx:2529
#: src/compose.jsx:84
msgid "Error"
msgstr "Erro"

#: src/components/compose.jsx:2554
msgid "Edit image description"
msgstr "Editar descrición da imaxe"

#: src/components/compose.jsx:2555
msgid "Edit video description"
msgstr "Editar descrición do vídeo"

#: src/components/compose.jsx:2556
msgid "Edit audio description"
msgstr "Editar descrición do audio"

#: src/components/compose.jsx:2601
#: src/components/compose.jsx:2650
msgid "Generating description. Please wait…"
msgstr "Creando a descrición. Agarda…"

#. placeholder {12}: e.message
#: src/components/compose.jsx:2621
msgid "Failed to generate description: {12}"
msgstr "Fallou a creación da descrición: {12}"

#: src/components/compose.jsx:2622
msgid "Failed to generate description"
msgstr "Fallou a creación da descrición"

#: src/components/compose.jsx:2634
#: src/components/compose.jsx:2640
#: src/components/compose.jsx:2686
msgid "Generate description…"
msgstr "Crear unha descrición…"

#. placeholder {13}: e?.message ? `: ${e.message}` : ''
#: src/components/compose.jsx:2673
msgid "Failed to generate description{13}"
msgstr "Fallou a creación da descrición{13}"

#. placeholder {0}: localeCode2Text(lang)
#: src/components/compose.jsx:2688
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/compose.jsx:2707
msgid "Done"
msgstr "Feito"

#. placeholder {0}: i + 1
#: src/components/compose.jsx:2743
msgid "Choice {0}"
msgstr "Opción {0}"

#: src/components/compose.jsx:2790
msgid "Multiple choices"
msgstr "Varias opcións"

#: src/components/compose.jsx:2793
msgid "Duration"
msgstr "Duración"

#: src/components/compose.jsx:2824
msgid "Remove poll"
msgstr "Retirar enquisa"

#: src/components/compose.jsx:3039
msgid "Search accounts"
msgstr "Buscar contas"

#: src/components/compose.jsx:3093
#: src/components/generic-accounts.jsx:228
msgid "Error loading accounts"
msgstr "Erro ao cargar as contas"

#: src/components/compose.jsx:3237
msgid "Custom emojis"
msgstr "Emojis personais"

#: src/components/compose.jsx:3257
msgid "Search emoji"
msgstr "Buscar emoji"

#: src/components/compose.jsx:3288
msgid "Error loading custom emojis"
msgstr "Erro ao cargar os emojis personais"

#: src/components/compose.jsx:3299
msgid "Recently used"
msgstr "Usados recentemente"

#: src/components/compose.jsx:3300
msgid "Others"
msgstr "Outros"

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/compose.jsx:3338
msgid "{0} more…"
msgstr "{0} mais…"

#: src/components/compose.jsx:3476
msgid "Search GIFs"
msgstr "Buscar GIFs"

#: src/components/compose.jsx:3491
msgid "Powered by GIPHY"
msgstr "Proporcionado por GIPHY"

#: src/components/compose.jsx:3499
msgid "Type to search GIFs"
msgstr "Escribe para buscar GIFs"

#: src/components/compose.jsx:3597
#: src/components/media-modal.jsx:462
#: src/components/timeline.jsx:893
msgid "Previous"
msgstr "Anterior"

#: src/components/compose.jsx:3615
#: src/components/media-modal.jsx:481
#: src/components/timeline.jsx:910
msgid "Next"
msgstr "Seguinte"

#: src/components/compose.jsx:3632
msgid "Error loading GIFs"
msgstr "Erro ao cargar GIFs"

#: src/components/drafts.jsx:64
#: src/pages/settings.jsx:693
msgid "Unsent drafts"
msgstr "Borradores non enviados"

#: src/components/drafts.jsx:69
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Semella que tes borradores sen enviar. Continuemos onde o deixaches."

#: src/components/drafts.jsx:103
msgid "Delete this draft?"
msgstr "Desbotar este borrador?"

#: src/components/drafts.jsx:118
msgid "Error deleting draft! Please try again."
msgstr "Erro ao desbotar o borrador! Inténtao outra vez."

#: src/components/drafts.jsx:128
#: src/components/list-add-edit.jsx:186
#: src/components/status.jsx:1352
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Eliminar…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr "Erro ao obter o estado ao que responder!"

#: src/components/drafts.jsx:172
msgid "Delete all drafts?"
msgstr "Desbotar todos os borradores?"

#: src/components/drafts.jsx:190
msgid "Error deleting drafts! Please try again."
msgstr "Erro ao eliminar os borradores! Inténtao outra vez."

#: src/components/drafts.jsx:202
msgid "Delete all…"
msgstr "Eliminar todo…"

#: src/components/drafts.jsx:210
msgid "No drafts found."
msgstr "Non hai borradores."

#: src/components/drafts.jsx:247
#: src/pages/catchup.jsx:1929
msgid "Poll"
msgstr "Enquisa"

#: src/components/drafts.jsx:250
#: src/pages/account-statuses.jsx:364
msgid "Media"
msgstr "Multimedia"

#: src/components/embed-modal.jsx:23
msgid "Open in new window"
msgstr "Abrir nunha nova xanela"

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:965
msgid "Accept"
msgstr "Aceptar"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "Rexeitar"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1249
msgid "Accepted"
msgstr "Aceptado"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "Rexeitado"

#: src/components/generic-accounts.jsx:146
#: src/components/notification.jsx:445
#: src/pages/accounts.jsx:42
#: src/pages/search.jsx:318
#: src/pages/search.jsx:351
msgid "Accounts"
msgstr "Contas"

#: src/components/generic-accounts.jsx:206
#: src/components/timeline.jsx:521
#: src/pages/list.jsx:295
#: src/pages/notifications.jsx:895
#: src/pages/search.jsx:545
#: src/pages/status.jsx:1334
msgid "Show more…"
msgstr "Mostrar máis…"

#: src/components/generic-accounts.jsx:211
#: src/components/timeline.jsx:526
#: src/pages/search.jsx:550
msgid "The end."
msgstr "Fin."

#: src/components/generic-accounts.jsx:232
msgid "Nothing to show"
msgstr "Nada que mostrar"

#: src/components/keyboard-shortcuts-help.jsx:44
#: src/components/nav-menu.jsx:357
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Atallos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:52
msgid "Keyboard shortcuts help"
msgstr "Axuda sobre atallos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:56
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Seguinte publicación"

#: src/components/keyboard-shortcuts-help.jsx:60
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Publicación anterior"

#: src/components/keyboard-shortcuts-help.jsx:64
msgid "Skip carousel to next post"
msgstr "Omitir carrusel e ir á seguinte publicación"

#: src/components/keyboard-shortcuts-help.jsx:66
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Maiús</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:72
msgid "Skip carousel to previous post"
msgstr "Omitir carrusel e ir á publicación anterior"

#: src/components/keyboard-shortcuts-help.jsx:74
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Maiús</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:80
msgid "Load new posts"
msgstr "Cargar novas publicacións"

#: src/components/keyboard-shortcuts-help.jsx:84
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Abrir detalles da publicación"

#: src/components/keyboard-shortcuts-help.jsx:86
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> ou <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:93
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Despregar o aviso sobre o contido ou<0/>pregar/despregar os fíos"

#: src/components/keyboard-shortcuts-help.jsx:102
msgid "Close post or dialogs"
msgstr "Fechar publicación ou diálogos"

#: src/components/keyboard-shortcuts-help.jsx:104
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> or <1>Retroceso</1>"

#: src/components/keyboard-shortcuts-help.jsx:110
msgid "Focus column in multi-column mode"
msgstr "Foco na columna no modo con varias columnas"

#: src/components/keyboard-shortcuts-help.jsx:112
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:118
msgid "Focus next column in multi-column mode"
msgstr "Foco na seguinte columna no modo multi-columna"

#: src/components/keyboard-shortcuts-help.jsx:122
msgid "Focus previous column in multi-column mode"
msgstr "Foco na columna anterior no modo multi-columna"

#: src/components/keyboard-shortcuts-help.jsx:126
msgid "Compose new post"
msgstr "Escribir nova publicación"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Compose new post (new window)"
msgstr "Escribir nova publicación (nova xanela)"

#: src/components/keyboard-shortcuts-help.jsx:133
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Maiús</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:139
msgid "Send post"
msgstr "Enviar publicación"

#: src/components/keyboard-shortcuts-help.jsx:141
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> ou <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:148
#: src/components/nav-menu.jsx:326
#: src/components/search-form.jsx:73
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:46
#: src/pages/search.jsx:300
msgid "Search"
msgstr "Buscar"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Reply (new window)"
msgstr "Responder (nova xanela)"

#: src/components/keyboard-shortcuts-help.jsx:159
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Maiús</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:165
msgid "Like (favourite)"
msgstr "Favorecer (favorita)"

#: src/components/keyboard-shortcuts-help.jsx:167
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> ou <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:173
#: src/components/status.jsx:937
#: src/components/status.jsx:2413
#: src/components/status.jsx:2444
#: src/components/status.jsx:2445
msgid "Boost"
msgstr "Promover"

#: src/components/keyboard-shortcuts-help.jsx:175
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Maiús</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:181
#: src/components/status.jsx:1022
#: src/components/status.jsx:2469
#: src/components/status.jsx:2470
msgid "Bookmark"
msgstr "Marcar"

#: src/components/keyboard-shortcuts-help.jsx:185
msgid "Toggle Cloak mode"
msgstr "Cambiar o Modo Capa"

#: src/components/keyboard-shortcuts-help.jsx:187
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Maiús</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:40
msgid "Edit list"
msgstr "Editar lista"

#: src/components/list-add-edit.jsx:96
msgid "Unable to edit list."
msgstr "Non se puido editar a lista."

#: src/components/list-add-edit.jsx:97
msgid "Unable to create list."
msgstr "Non se puido crear a lista."

#: src/components/list-add-edit.jsx:125
msgid "Show replies to list members"
msgstr "Mostrar respostas a membros da lista"

#: src/components/list-add-edit.jsx:128
msgid "Show replies to people I follow"
msgstr "Mostrar respostas a persoas que sigo"

#: src/components/list-add-edit.jsx:131
msgid "Don't show replies"
msgstr "Non mostrar respostas"

#: src/components/list-add-edit.jsx:144
msgid "Hide posts on this list from Home/Following"
msgstr "Nesta lista, agochar as publicacións que están en Inicio/Seguindo"

#: src/components/list-add-edit.jsx:150
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Crear"

#: src/components/list-add-edit.jsx:157
msgid "Delete this list?"
msgstr "Eliminar esta lista?"

#: src/components/list-add-edit.jsx:176
msgid "Unable to delete list."
msgstr "Non se puido eliminar a lista."

#: src/components/media-alt-modal.jsx:39
#: src/components/media.jsx:51
msgid "Media description"
msgstr "Descrición do multimedia"

#: src/components/media-alt-modal.jsx:58
#: src/components/status.jsx:1066
#: src/components/status.jsx:1093
#: src/components/translation-block.jsx:196
msgid "Translate"
msgstr "Traducir"

#: src/components/media-alt-modal.jsx:69
#: src/components/status.jsx:1080
#: src/components/status.jsx:1107
msgid "Speak"
msgstr "Falar"

#: src/components/media-modal.jsx:369
msgid "Open original media in new window"
msgstr "Abrir multimedia orixinal nunha nova xanela"

#: src/components/media-modal.jsx:373
msgid "Open original media"
msgstr "Abrir multimedia orixinal"

#: src/components/media-modal.jsx:389
msgid "Attempting to describe image. Please wait…"
msgstr "Intentando describir a imaxe. Agarda…"

#: src/components/media-modal.jsx:404
msgid "Failed to describe image"
msgstr "Non se puido describir a imaxe"

#: src/components/media-modal.jsx:414
msgid "Describe image…"
msgstr "Describir a imaxe…"

#: src/components/media-modal.jsx:437
msgid "View post"
msgstr "Ver publicación"

#: src/components/media-post.jsx:128
msgid "Sensitive media"
msgstr "Multimedia sensible"

#: src/components/media-post.jsx:133
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrado: {filterTitleStr}"

#: src/components/media-post.jsx:134
#: src/components/status.jsx:3563
#: src/components/status.jsx:3659
#: src/components/status.jsx:3737
#: src/components/timeline.jsx:978
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1877
msgid "Filtered"
msgstr "Filtrado"

#: src/components/modals.jsx:73
msgid "Post published. Check it out."
msgstr "Publicouse a mensaxe. Compróbao."

#: src/components/modals.jsx:74
msgid "Reply posted. Check it out."
msgstr "Publicouse a resposta. Compróbao."

#: src/components/modals.jsx:75
msgid "Post updated. Check it out."
msgstr "Actualizouse a publicación. Compróbao."

#: src/components/nav-menu.jsx:118
msgid "Menu"
msgstr "Menú"

#: src/components/nav-menu.jsx:154
msgid "Reload page now to update?"
msgstr "Volver cargar a páxina para actualizar?"

#: src/components/nav-menu.jsx:166
msgid "New update available…"
msgstr "Nova actualización dispoñible…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:185
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:23
#: src/pages/following.jsx:142
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:192
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Ponte ao día"

#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:225
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:168
#: src/pages/settings.jsx:1147
#: src/pages/trending.jsx:382
msgid "Mentions"
msgstr "Mencións"

#: src/components/nav-menu.jsx:206
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:23
#: src/pages/home.jsx:85
#: src/pages/home.jsx:185
#: src/pages/notifications.jsx:113
#: src/pages/notifications.jsx:564
msgid "Notifications"
msgstr "Notificacións"

#: src/components/nav-menu.jsx:209
msgid "New"
msgstr "Novidade"

#: src/components/nav-menu.jsx:220
msgid "Profile"
msgstr "Perfil"

#: src/components/nav-menu.jsx:228
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:24
msgid "Bookmarks"
msgstr "Marcadores"

#: src/components/nav-menu.jsx:248
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2064
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:24
#: src/pages/settings.jsx:1151
msgid "Likes"
msgstr "Favorecementos"

#: src/components/nav-menu.jsx:254
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "Cancelos seguidos"

#: src/components/nav-menu.jsx:262
#: src/pages/account-statuses.jsx:330
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:340
msgid "Filters"
msgstr "Filtros"

#: src/components/nav-menu.jsx:270
msgid "Muted users"
msgstr "Usuarias acaladas"

#: src/components/nav-menu.jsx:278
msgid "Muted users…"
msgstr "Usuarias acaladas…"

#: src/components/nav-menu.jsx:285
msgid "Blocked users"
msgstr "Usuarias bloqueadas"

#: src/components/nav-menu.jsx:293
msgid "Blocked users…"
msgstr "Usuarias bloqueadas…"

#: src/components/nav-menu.jsx:305
msgid "Accounts…"
msgstr "Contas…"

#: src/components/nav-menu.jsx:315
#: src/pages/login.jsx:190
#: src/pages/status.jsx:837
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr "Acceder"

#: src/components/nav-menu.jsx:332
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:442
msgid "Trending"
msgstr "En voga"

#: src/components/nav-menu.jsx:344
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federada"

#: src/components/nav-menu.jsx:367
msgid "Shortcuts / Columns…"
msgstr "Atallos / Columnas…"

#: src/components/nav-menu.jsx:377
#: src/components/nav-menu.jsx:391
msgid "Settings…"
msgstr "Axustes…"

#: src/components/nav-menu.jsx:421
#: src/components/nav-menu.jsx:448
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:17
#: src/pages/lists.jsx:51
msgid "Lists"
msgstr "Listas"

#: src/components/nav-menu.jsx:429
#: src/components/shortcuts.jsx:215
#: src/pages/list.jsx:134
msgid "All Lists"
msgstr "Todas as Listas"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "Notificación"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "Esta notificación procede de outra conta."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "Ver todas as notificacións"

#: src/components/notification.jsx:71
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reaccionou á túa publicación con {emojiObject}"

#: src/components/notification.jsx:78
msgid "{account} published a post."
msgstr "{account} enviou unha publicación."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:86
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} promoveu a túa resposta.} other {{account} promoveu a túa publicación.}}} other {{account} promoveu {postsCount} das túas publicacións.}}} other {{postType, select, reply {<0><1>{0}</1> persoas</0> promoveron a túa resposta.} other {<2><3>{1}</3> persoas</2> promoveron a túa publicación.}}}}"

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:129
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, one {}=1 {{account} seguiute.} other {<0><1>{0}</1> persoas</0> seguíronte.}}"

#: src/components/notification.jsx:143
msgid "{account} requested to follow you."
msgstr "{account} solicitou seguirte."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:152
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural,  =1 {{postsCount, plural, =1 {{postType, select, reply {a {account} gustoulle a túa resposta.} other {a {account} gustoulle a túa publicación.}}} other {a {account} gustoulle {postsCount} das túas publicacións.}}} other {{postType, select, reply {a <0><1>{0}</1> persoas</0> gustoulle a túa resposta.} other {a <2><3>{1}</3> persoas</2> gustoulle a túa publicación.}}}}"

#: src/components/notification.jsx:194
msgid "A poll you have voted in or created has ended."
msgstr "Finalizou unha enquisa creada por ti ou na que votaches."

#: src/components/notification.jsx:195
msgid "A poll you have created has ended."
msgstr "Finalizou unha enquisa creada por ti."

#: src/components/notification.jsx:196
msgid "A poll you have voted in has ended."
msgstr "Finalizou unha enquisa na que votaches."

#: src/components/notification.jsx:197
msgid "A post you interacted with has been edited."
msgstr "Editouse unha publicación coa que interactuaches."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:205
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {a {account} gustoulle e promoveu a túa resposta.} other {a {account} gustoulle e promoveu a túa publicación.}}} other {a {account} gustoulle e promoveu {postsCount} das túas publicacións.}}} other {{postType, select, reply {a <0><1>{0}</1> persoas</0> gustoulles e promoveron a túa resposta.} other {a <2><3>{1}</3> persoas</2> gustoulle e promoveron a túa publicación.}}}}"

#: src/components/notification.jsx:247
msgid "{account} signed up."
msgstr "{account} creou a conta."

#: src/components/notification.jsx:249
msgid "{account} reported {targetAccount}"
msgstr "{account} denunciou a {targetAccount}"

#: src/components/notification.jsx:254
msgid "Lost connections with <0>{name}</0>."
msgstr "Conexións perdidas con <0>{name}</0>."

#: src/components/notification.jsx:260
msgid "Moderation warning"
msgstr "Aviso da Moderación"

#: src/components/notification.jsx:265
msgid "Your {year} #Wrapstodon is here!"
msgstr "Xa chegou o teu {year} #Wrapstodon!"

#: src/components/notification.jsx:271
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "A administración de <0>{from}</0> suspendeu a <1>{targetName}</1>, xa que logo non vas recibir actualizacións desa conta ou interactuar con ela."

#: src/components/notification.jsx:277
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "A administración de <0>{from}</0> bloqueou a <1>{targetName}</1>. Seguidoras afectadas: {followersCount}; seguimentos: {followingCount}."

#: src/components/notification.jsx:283
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Bloqueaches a <0>{targetName}</0>. Seguidoras eliminadas: {followersCount}; seguimentos: {followingCount}."

#: src/components/notification.jsx:291
msgid "Your account has received a moderation warning."
msgstr "A túa conta recibeu unha advertencia da moderación."

#: src/components/notification.jsx:292
msgid "Your account has been disabled."
msgstr "A túa conta foi desactivada."

#: src/components/notification.jsx:293
msgid "Some of your posts have been marked as sensitive."
msgstr "Algunha das túas publicacións foron marcadas como sensibles."

#: src/components/notification.jsx:294
msgid "Some of your posts have been deleted."
msgstr "Algunha das túas publicacións foron eliminadas."

#: src/components/notification.jsx:295
msgid "Your posts will be marked as sensitive from now on."
msgstr "De agora en diante as túas publicacións van ser marcadas como sensibles."

#: src/components/notification.jsx:296
msgid "Your account has been limited."
msgstr "A túa conta foi limitada."

#: src/components/notification.jsx:297
msgid "Your account has been suspended."
msgstr "A túa conta foi suspendida."

#: src/components/notification.jsx:372
msgid "[Unknown notification type: {type}]"
msgstr "[Tipo de notificación descoñecido: {type}]"

#: src/components/notification.jsx:441
#: src/components/status.jsx:1036
#: src/components/status.jsx:1046
msgid "Boosted/Liked by…"
msgstr "Promovida/Favorecida por…"

#: src/components/notification.jsx:442
msgid "Liked by…"
msgstr "Favorecida por…"

#: src/components/notification.jsx:443
msgid "Boosted by…"
msgstr "Promovida por…"

#: src/components/notification.jsx:444
msgid "Followed by…"
msgstr "Seguida por…"

#: src/components/notification.jsx:515
#: src/components/notification.jsx:531
msgid "Learn more <0/>"
msgstr "Saber mais <0/>"

#: src/components/notification.jsx:540
msgid "View #Wrapstodon"
msgstr "Ver #Wrapstodon"

#: src/components/notification.jsx:770
#: src/components/status.jsx:267
msgid "Read more →"
msgstr "Ler mais →"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "Xa votaches"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# voto} other {# votos}}"

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "Agochar resultados"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "Votar"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/status.jsx:1203
#: src/pages/status.jsx:1226
msgid "Refresh"
msgstr "Actualizar"

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "Mostrar resultados"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voto} other {<1>{1}</1> votos}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votante} other {<1>{1}</1> votantes}}"

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "Finalizou <0/>"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "Finalizou"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "Finaliza en <0/>"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "Finaliza"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Ligazóns maliciosas, relacións engañosas, ou respostas repetitivas"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Ilegalidade"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola as leis do país do servidor"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Violación das regras do servidor"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Contravén as regras propias do servidor"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violación"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Outra"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "O problema non cae en ningunha das categorías"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Denunciar Publicación"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Denunciar a @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Pendente de revisión"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Publicación denunciada"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Perfil denunciado"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Non se puido denunciar a publicación"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Non se puido denunciar ao perfil"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Cal é o problema con esta publicación?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Cal é o problema con este perfil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Info adicional"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Reenviar a <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Enviar Denuncia"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silenciou a {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Non se puido acalar a {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Enviar Denuncia <0>+Silenciar perfil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Bloqueouse a {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Non se puido bloquear a {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Enviar Denuncia <0>+ Bloquear o perfil</0>"

#: src/components/search-form.jsx:203
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ contas, cancelos e publicacións</0>"

#: src/components/search-form.jsx:216
msgid "Posts with <0>{query}</0>"
msgstr "Publicacións con <0>{query}</0>"

#. placeholder {0}: query.replace(/^#/, '')
#: src/components/search-form.jsx:228
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Publicacións co cancelo <0>#{0}</0>"

#: src/components/search-form.jsx:242
msgid "Look up <0>{query}</0>"
msgstr "Busca de <0>{query}</0>"

#: src/components/search-form.jsx:253
msgid "Accounts with <0>{query}</0>"
msgstr "Contas con <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Inicio / Seguindo"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Pública (Local / Federada)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Conta"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Cancelo"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID da lista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Só local"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:194
msgid "Instance"
msgstr "Instancia"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Optativo, ex. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Termo a buscar"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Optativo, a non ser para o modo de varias columnas"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "ex. PixelArt (Máx 5, separado por espazos)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:356
msgid "Media only"
msgstr "Só multimedia"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:192
msgid "Shortcuts"
msgstr "Atallos"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Indicar unha lista de atallos que aparecerán como:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Botón flotante"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Barra con Menú/Pestana"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Varias columnas"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Non dispoñible coa visualización actual"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Ir arriba"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Ir abaixo"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1314
#: src/pages/list.jsx:171
msgid "Edit"
msgstr "Editar"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Engadir máis de un atallo/columna para que isto funcione."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Aínda non hai columnas. Toca no botón Engadir columna."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Aínda non hai atallos. Toca no botón Engadir atallo."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Non sabes que engadir?<0/>Intenta engadir <1>Inicio / Seguindo e Notificacións</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Máx {SHORTCUTS_LIMIT} columnas"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Máx {SHORTCUTS_LIMIT} atallos"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importar/exportar"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Engadir columna…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Engadir atallo…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "É opcional seleccionar unha lista. No modo de varias columnas hai que indicar unha, se non non se mostrará."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "No modo de varias columnas, requírese unha palabra a buscar, se non a columna no se vai mostrar."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Hai compatibilidade para varios cancelos, separados por espazos."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Editar atallo"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Engadir atallo"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Cronoloxía"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Lista"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importar/Exportar <0>Atallos</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importar"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Pega aquí os atallos"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "A descargar os atallos gardados desde o servidor da instancia…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Non se puideron descargar os atallos"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Descargar atallos desde o servidor da instancia"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Existe nos atallos actuais"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "A lista podería non funcionar se procede de outra conta."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "O formato dos axustes non é válido"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Engadir aos atallos actuais?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Só se engadirán os atallos que non existan nos atallos actuais."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Non hai atallos que importar"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Importáronse os atallos. Excedeuse o máximo de {SHORTCUTS_LIMIT}, así que o resto non se importaron."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Atallos importados"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importar e engadir…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Sobrescribir os atallos actuais?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Importar os atallos?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "ou sobrescribir…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importar…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Exportar"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Copiáronse os atallos"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Non se puideron copiar os atallos"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Copiáronse os axustes do atallo"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Non se puideron copiar os axustes do atallo"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Compartir"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "A gardar os atallos no servidor da instancia…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Gardáronse os atallos"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Non se puideron gardar os atallos"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sincronizar co servidor da instancia"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# caracter} other {# caracteres}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Atallos en formato JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importar/exportar os axustes de/para o servidor da instancia (moi experimental)"

#: src/components/status.jsx:538
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>promoveu</1>"

#: src/components/status.jsx:637
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Sentímolo pero a instancia na que iniciaches sesión non pode interactuar coa publicación desde outra instancia."

#. placeholder {0}: username || acct
#: src/components/status.jsx:790
msgid "Unliked @{0}'s post"
msgstr "Retirado o favorecemento a @{0}"

#. placeholder {1}: username || acct
#: src/components/status.jsx:791
msgid "Liked @{1}'s post"
msgstr "Favorecida a publicación de @{1}"

#. placeholder {2}: username || acct
#: src/components/status.jsx:830
msgid "Unbookmarked @{2}'s post"
msgstr "Desmarcouse a publicación de @{2}"

#. placeholder {3}: username || acct
#: src/components/status.jsx:831
msgid "Bookmarked @{3}'s post"
msgstr "Marcouse a publicación de @{3}"

#: src/components/status.jsx:937
#: src/components/status.jsx:999
#: src/components/status.jsx:2413
#: src/components/status.jsx:2444
msgid "Unboost"
msgstr "Retirar promoción"

#: src/components/status.jsx:953
#: src/components/status.jsx:2428
msgid "Quote"
msgstr "Cita"

#: src/components/status.jsx:961
#: src/components/status.jsx:2437
msgid "Some media have no descriptions."
msgstr "Algún multimedia non ten descrición."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:968
msgid "Old post (<0>{0}</0>)"
msgstr "Publicación antiga (<0>{0}</0>)"

#. placeholder {4}: username || acct
#: src/components/status.jsx:987
msgid "Unboosted @{4}'s post"
msgstr "Retirada a promoción da publicación de @{4}"

#. placeholder {5}: username || acct
#: src/components/status.jsx:988
msgid "Boosted @{5}'s post"
msgstr "Promoveu a publicación de @{5}"

#: src/components/status.jsx:1000
msgid "Boost…"
msgstr "Promover…"

#: src/components/status.jsx:1012
#: src/components/status.jsx:1727
#: src/components/status.jsx:2457
msgid "Unlike"
msgstr "Xa non me gusta"

#: src/components/status.jsx:1013
#: src/components/status.jsx:1727
#: src/components/status.jsx:1728
#: src/components/status.jsx:2457
#: src/components/status.jsx:2458
msgid "Like"
msgstr "Gústame"

#: src/components/status.jsx:1022
#: src/components/status.jsx:2469
msgid "Unbookmark"
msgstr "Retirar marcador"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1130
msgid "View post by <0>@{0}</0>"
msgstr "Ver publicación de <0>@{0}</0>"

#: src/components/status.jsx:1151
msgid "Show Edit History"
msgstr "Mostrar historial de edicións"

#: src/components/status.jsx:1154
msgid "Edited: {editedDateText}"
msgstr "Editada: {editedDateText}"

#: src/components/status.jsx:1221
#: src/components/status.jsx:3238
msgid "Embed post"
msgstr "Inclúe a publicación"

#: src/components/status.jsx:1235
msgid "Conversation unmuted"
msgstr "Conversa reactivada"

#: src/components/status.jsx:1235
msgid "Conversation muted"
msgstr "Conversa acalada"

#: src/components/status.jsx:1241
msgid "Unable to unmute conversation"
msgstr "Non se puido reactivar a conversa"

#: src/components/status.jsx:1242
msgid "Unable to mute conversation"
msgstr "Non se puido acalar a conversa"

#: src/components/status.jsx:1251
msgid "Unmute conversation"
msgstr "Reactivar a conversa"

#: src/components/status.jsx:1258
msgid "Mute conversation"
msgstr "Acalar conversa"

#: src/components/status.jsx:1274
msgid "Post unpinned from profile"
msgstr "Desprendeuse do perfil a publicación"

#: src/components/status.jsx:1275
msgid "Post pinned to profile"
msgstr "Publicación fixada ao perfil"

#: src/components/status.jsx:1280
msgid "Unable to unpin post"
msgstr "Non se puido desprender a publicación"

#: src/components/status.jsx:1280
msgid "Unable to pin post"
msgstr "Non se puido fixar a publicación"

#: src/components/status.jsx:1289
msgid "Unpin from profile"
msgstr "Soltar do perfil"

#: src/components/status.jsx:1296
msgid "Pin to profile"
msgstr "Fixar no perfil"

#: src/components/status.jsx:1325
msgid "Delete this post?"
msgstr "Eliminar publicación?"

#: src/components/status.jsx:1341
msgid "Post deleted"
msgstr "Eliminouse a publicación"

#: src/components/status.jsx:1344
msgid "Unable to delete post"
msgstr "Non se puido eliminar a publicación"

#: src/components/status.jsx:1372
msgid "Report post…"
msgstr "Denunciar publicación…"

#. placeholder {6}: username || acct
#: src/components/status.jsx:1442
msgid "Unboosted @{6}'s post"
msgstr "Retirou a promoción da publicación de @{6}"

#. placeholder {7}: username || acct
#: src/components/status.jsx:1443
msgid "Boosted @{7}'s post"
msgstr "Promoveu a publicación de @{7}"

#: src/components/status.jsx:1728
#: src/components/status.jsx:1764
#: src/components/status.jsx:2458
msgid "Liked"
msgstr "Favorecida"

#: src/components/status.jsx:1761
#: src/components/status.jsx:2445
msgid "Boosted"
msgstr "Promovida"

#: src/components/status.jsx:1771
#: src/components/status.jsx:2470
msgid "Bookmarked"
msgstr "Marcada"

#: src/components/status.jsx:1775
msgid "Pinned"
msgstr "Fixada"

#: src/components/status.jsx:1820
#: src/components/status.jsx:2276
msgid "Deleted"
msgstr "Eliminada"

#: src/components/status.jsx:1861
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# resposta} other {# respostas}}"

#. placeholder {0}: snapStates.statusThreadNumber[sKey] ? ` ${snapStates.statusThreadNumber[sKey]}/X` : ''
#: src/components/status.jsx:1950
msgid "Thread{0}"
msgstr "Fío{0}"

#: src/components/status.jsx:2026
#: src/components/status.jsx:2088
#: src/components/status.jsx:2173
msgid "Show less"
msgstr "Ver menos"

#: src/components/status.jsx:2026
#: src/components/status.jsx:2088
msgid "Show content"
msgstr "Mostrar contido"

#: src/components/status.jsx:2173
msgid "Show media"
msgstr "Mostrar multimedia"

#: src/components/status.jsx:2310
msgid "Edited"
msgstr "Editada"

#: src/components/status.jsx:2387
msgid "Comments"
msgstr "Comentarios"

#. More from [Author]
#: src/components/status.jsx:2696
msgid "More from <0/>"
msgstr "Mais de <0/>"

#: src/components/status.jsx:2998
msgid "Edit History"
msgstr "Editar Historial"

#: src/components/status.jsx:3002
msgid "Failed to load history"
msgstr "Fallou a carga do historial"

#: src/components/status.jsx:3007
#: src/pages/annual-report.jsx:45
msgid "Loading…"
msgstr "A cargar…"

#: src/components/status.jsx:3243
msgid "HTML Code"
msgstr "Código HTML"

#: src/components/status.jsx:3260
msgid "HTML code copied"
msgstr "Copiouse o código HTML"

#: src/components/status.jsx:3263
msgid "Unable to copy HTML code"
msgstr "Non se puido copiar o código HTML"

#: src/components/status.jsx:3275
msgid "Media attachments:"
msgstr "Anexos multimedia:"

#: src/components/status.jsx:3297
msgid "Account Emojis:"
msgstr "Emojis da conta:"

#: src/components/status.jsx:3328
#: src/components/status.jsx:3373
msgid "static URL"
msgstr "URL estático"

#: src/components/status.jsx:3342
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3387
msgid "Notes:"
msgstr "Notas:"

#: src/components/status.jsx:3391
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Isto é contido estático, sen estilo nin scripts. Pode que teñas que aplicar o teu propio estilo e adaptalo ás necesidades."

#: src/components/status.jsx:3397
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "As enquisas non son interactivas, convértese nunha lista con conta dos votos."

#: src/components/status.jsx:3402
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "O multimedia anexo poden ser imaxes, vídeos, audios ou varios tipos de ficheiros."

#: src/components/status.jsx:3408
msgid "Post could be edited or deleted later."
msgstr "A publicación pode editarse ou eliminarse con posterioridade."

#: src/components/status.jsx:3414
msgid "Preview"
msgstr "Vista previa"

#: src/components/status.jsx:3423
msgid "Note: This preview is lightly styled."
msgstr "Nota: a vista previa está lixeiramente editada."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3667
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> promoveu"

#: src/components/timeline.jsx:455
#: src/pages/settings.jsx:1175
msgid "New posts"
msgstr "Novas publicacións"

#: src/components/timeline.jsx:556
#: src/pages/home.jsx:214
#: src/pages/notifications.jsx:871
#: src/pages/status.jsx:990
#: src/pages/status.jsx:1363
msgid "Try again"
msgstr "Inténtao outra vez"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:591
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Promoción} other {# Promocións}}"

#: src/components/timeline.jsx:596
msgid "Pinned posts"
msgstr "Publicacións fixadas"

#: src/components/timeline.jsx:951
#: src/components/timeline.jsx:958
#: src/pages/catchup.jsx:1894
msgid "Thread"
msgstr "Fío"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:973
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrado</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:153
msgid "Auto-translated from {sourceLangText}"
msgstr "Tradución automática desde o {sourceLangText}"

#: src/components/translation-block.jsx:191
msgid "Translating…"
msgstr "A traducir…"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traducir do {sourceLangText} (detección automática)"

#: src/components/translation-block.jsx:195
msgid "Translate from {sourceLangText}"
msgstr "Traducir do {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:223
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:236
msgid "Failed to translate"
msgstr "Fallou a tradución"

#: src/compose.jsx:33
msgid "Editing source status"
msgstr "A editar o contido do estado"

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:35
msgid "Replying to @{0}"
msgstr "En resposta a @{0}"

#: src/compose.jsx:63
msgid "You may close this page now."
msgstr "Xa podes fechar esta páxina."

#: src/compose.jsx:71
msgid "Close window"
msgstr "Fechar xanela"

#: src/compose.jsx:87
msgid "Login required."
msgstr "Precisa acceder."

#: src/compose.jsx:91
#: src/pages/annual-report.jsx:164
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:271
msgid "Go home"
msgstr "Ir ao inicio"

#: src/pages/account-statuses.jsx:232
msgid "Account posts"
msgstr "Publicacións da conta"

#: src/pages/account-statuses.jsx:239
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Respostas)"

#: src/pages/account-statuses.jsx:241
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Promocións)"

#: src/pages/account-statuses.jsx:243
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:245
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Multimedia)"

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:320
msgid "Clear filters"
msgstr "Limpar filtros"

#: src/pages/account-statuses.jsx:323
msgid "Clear"
msgstr "Limpar"

#: src/pages/account-statuses.jsx:337
msgid "Showing post with replies"
msgstr "Mostrando publicacións con resposta"

#: src/pages/account-statuses.jsx:342
msgid "+ Replies"
msgstr "+ Respostas"

#: src/pages/account-statuses.jsx:348
msgid "Showing posts without boosts"
msgstr "Mostrando publicacións sen promocións"

#: src/pages/account-statuses.jsx:353
msgid "- Boosts"
msgstr "- Promocións"

#: src/pages/account-statuses.jsx:359
msgid "Showing posts with media"
msgstr "Mostrando publicacións con multimedia"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:376
msgid "Showing posts tagged with #{0}"
msgstr "Mostrando publicacións etiquetadas con #{0}"

#. placeholder {1}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:415
msgid "Showing posts in {1}"
msgstr "Mostrando as publicacións de {1}"

#: src/pages/account-statuses.jsx:504
msgid "Nothing to see here yet."
msgstr "Aínda non hai nada que ver."

#: src/pages/account-statuses.jsx:505
#: src/pages/public.jsx:98
#: src/pages/trending.jsx:450
msgid "Unable to load posts"
msgstr "Non se puideron cargar as publicacións"

#: src/pages/account-statuses.jsx:546
#: src/pages/account-statuses.jsx:576
msgid "Unable to fetch account info"
msgstr "Non se puido obter a información da conta"

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:553
msgid "Switch to account's instance {0}"
msgstr "Cambiar á instancia da conta {0}"

#: src/pages/account-statuses.jsx:583
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Cambiar á miña instancia (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:645
msgid "Month"
msgstr "Mes"

#: src/pages/accounts.jsx:56
msgid "Current"
msgstr "Actual"

#: src/pages/accounts.jsx:102
msgid "Default"
msgstr "Por defecto"

#: src/pages/accounts.jsx:124
msgid "Switch to this account"
msgstr "Cambiar a esta conta"

#: src/pages/accounts.jsx:133
msgid "Switch in new tab/window"
msgstr "Cambiar en nova pestana/xanela"

#: src/pages/accounts.jsx:147
msgid "View profile…"
msgstr "Ver perfil…"

#: src/pages/accounts.jsx:164
msgid "Set as default"
msgstr "Establecer por defecto"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:174
msgid "Log out <0>@{0}</0>?"
msgstr "Pechar a sesión de <0>@{0}</0>?"

#: src/pages/accounts.jsx:197
msgid "Log out…"
msgstr "Fechar sesión…"

#: src/pages/accounts.jsx:210
msgid "Add an existing account"
msgstr "Engadir unha conta existente"

#: src/pages/accounts.jsx:217
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Nota: A conta <0>por defecto</0> sempre será a que se mostre ao iniciar. O cambio de conta manterase durante a sesión."

#: src/pages/bookmarks.jsx:26
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Non tes marcadores, vai mirar e garda o que che interese!"

#: src/pages/bookmarks.jsx:27
msgid "Unable to load bookmarks."
msgstr "Non se cargaron os marcadores."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "última hora"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "últimas 2 horas"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "últimas 3 horas"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "últimas 4 horas"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "últimas 5 horas"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "últimas 6 horas"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "últimas 7 horas"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "últimas 8 horas"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "últimas 9 horas"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "últimas 10 horas"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "últimas 11 horas"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "últimas 12 horas"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "máis de 12 horas"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Cancelos seguidos"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grupos"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Móstrase {selectedFilterCategory, select, all {todas as publicacións} original {publicacións orixinais} replies {respostas} boosts {promocións} followedTags {cancelos seguidos} groups {grupos} filtered {publicacións filtradas}}, {sortBy, select, createdAt {{sortOrder, select, asc {máis antigo} desc {máis recente}}} reblogsCount {{sortOrder, select, asc {con menos promocións} desc {con máis promocións}}} favouritesCount {{sortOrder, select, asc {con menos favorecementos} desc {con máis favorecementos}}} repliesCount {{sortOrder, select, asc {con menos respostas} desc {con máis respostas}}} density {{sortOrder, select, asc {menor densidade} desc {maior densidade}}}} primeiro{groupBy, select, account {, agrupado por autoría} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Ponte ao día <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Axuda"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Que é isto?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Ponte ao Día é unha cronoloxía separada para os teus seguimentos onde obter unha visión rápida e doada do publicado, cunha interface inspirada na do correo electrónico para organizar e filtrar as publicacións."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Vista previa da interface de Ponte ao día"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Poñámonos ao día"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Vexamos o que publicaron as persoas que segues."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Móstrame todas as publicacións das…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "o máximo"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Obter"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Entraría na túa última posta ao día"

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Ata a última posta ao día ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: pode que a túa instancia mostre un máximo de 800 publicacións na cronoloxía de Inicio independentemente do tempo que marques. Podería variar."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Anteriormente…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# publicación} other {# publicacións}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Retirar esta posta ao día?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1065
msgid "Removing Catch-up {0}"
msgstr "Retirar Ponte ao Día {0}"

#. placeholder {1}: pc.id
#: src/pages/catchup.jsx:1069
msgid "Catch-up {1} removed"
msgstr "Eliminouse o Ponte ao Día {1}"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: só se gardan 3 postas ao día. O resto elimínanse automaticamente."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Obtendo as publicacións…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Podería levarlle un anaco."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Restablecer filtros"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "O máis compartido"

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Compartido por {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:148
#: src/pages/search.jsx:313
msgid "All"
msgstr "Todo"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autora} other {# autoras}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Orde"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Densidade"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1471
msgid "group.filter"
msgstr ""

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Autoría"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Ningún"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Mostra todas as autoras"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Non tes que ler todo."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "Isto é todo."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Volver arriba"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Ligazóns compartidas polos teus seguimentos, organizados por contas compartidas, promocións e favorecementos."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Orde: Densidade"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "As publicacións están ordenadas pola densidade de información, pola cantidade relativa. As publicacións curtas son «lixeiras» mentres que as máis longas «pesan máis». As publicacións con fotos «pesan máis» que as que non as teñen."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Agrupar: Autoría"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "As publicacións están agrupadas pola autoría, e ordenadas por número de publicacións por autora."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Seguinte autora"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Autora anterior"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Ir arriba"

#. placeholder {0}: filterInfo.titlesStr
#: src/pages/catchup.jsx:1876
msgid "Filtered: {0}"
msgstr "Filtrado: {0}"

#: src/pages/favourites.jsx:26
msgid "No likes yet. Go like something!"
msgstr "Sen favoritas. Reparte ❤️! "

#: src/pages/favourites.jsx:27
msgid "Unable to load likes."
msgstr "Non se cargaron os favorecementos."

#: src/pages/filters.jsx:22
msgid "Home and lists"
msgstr "Inicio e listas"

#: src/pages/filters.jsx:24
msgid "Public timelines"
msgstr "Cronoloxías públicas"

#: src/pages/filters.jsx:25
msgid "Conversations"
msgstr "Conversas"

#: src/pages/filters.jsx:26
msgid "Profiles"
msgstr "Perfís"

#: src/pages/filters.jsx:41
msgid "Never"
msgstr "Nunca"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Novo filtro"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtro} other {# filtros}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Non se cargaron os filtros."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Aínda non hai filtros."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Engadir filtro"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Editar filtro"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Non se puido editar o filtro"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Non se puido crear o filtro"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Título"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Palabra completa"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Sen palabras chave. Engade unha."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Engadir palabra chave"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# palabra chave} other {# palabras chave}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtro desde…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Aínda non se aplicou"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Estado: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Cambiar a caducidade"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Caducidade"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "A publicación filtrada será…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimizadas"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "agochadas"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Eliminar este filtro?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Non se puido eliminar o filtro."

#: src/pages/filters.jsx:609
msgid "Expired"
msgstr "Finalizou"

#: src/pages/filters.jsx:611
msgid "Expiring <0/>"
msgstr "Finaliza en <0/>"

#: src/pages/filters.jsx:615
msgid "Never expires"
msgstr "Non finaliza"

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# cancelo} other {# cancelos}}"

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "Non se puideron cargar os cancelos seguidos."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "Aínda non segues ningún cancelo."

#: src/pages/following.jsx:144
msgid "Nothing to see here."
msgstr "Non hai nada que ver aquí."

#: src/pages/following.jsx:145
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "Non se puideron cargar as publicacións."

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Só multimedia) en {instance}"

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} en {instance}"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Só multimedia)"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:182
msgid "No one has posted anything with this tag yet."
msgstr "Ninguén publicou usando este cancelo por agora."

#: src/pages/hashtag.jsx:183
msgid "Unable to load posts with this tag"
msgstr "Non se puideron cargar publicacións con este cancelo"

#: src/pages/hashtag.jsx:209
msgid "Unfollow #{hashtag}?"
msgstr "Deixar de seguir #{hashtag}?"

#: src/pages/hashtag.jsx:224
msgid "Unfollowed #{hashtag}"
msgstr "Retirouse o seguimento a #{hashtag}"

#: src/pages/hashtag.jsx:239
msgid "Followed #{hashtag}"
msgstr "Seguiches a #{hashtag}"

#: src/pages/hashtag.jsx:255
msgid "Following…"
msgstr "Seguindo…"

#: src/pages/hashtag.jsx:283
msgid "Unfeatured on profile"
msgstr "Non se mostra no perfil"

#: src/pages/hashtag.jsx:297
msgid "Unable to unfeature on profile"
msgstr "Non se retirou dos destacados no perfil"

#: src/pages/hashtag.jsx:306
#: src/pages/hashtag.jsx:322
msgid "Featured on profile"
msgstr "Destacado no perfil"

#: src/pages/hashtag.jsx:329
msgid "Feature on profile"
msgstr "Destacar no perfil"

#: src/pages/hashtag.jsx:394
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, one {}other {Máx # cancelos}}"

#: src/pages/hashtag.jsx:397
msgid "Add hashtag"
msgstr "Engadir cancelo"

#: src/pages/hashtag.jsx:429
msgid "Remove hashtag"
msgstr "Retirar cancelo"

#: src/pages/hashtag.jsx:443
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Acadouse o máx. de # atallo. Non se puido engadir outro.} other {Acadouse o máx. de # atallos. Non se puido engadir outro.}}"

#: src/pages/hashtag.jsx:472
msgid "This shortcut already exists"
msgstr "Xa existe este atallo"

#: src/pages/hashtag.jsx:475
msgid "Hashtag shortcut added"
msgstr "Engadiuse o atallo ao cancelo"

#: src/pages/hashtag.jsx:481
msgid "Add to Shortcuts"
msgstr "Engadir a Atallos"

#: src/pages/hashtag.jsx:487
#: src/pages/public.jsx:140
#: src/pages/trending.jsx:479
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Escribe unha nova instancia, ex. \"mastodon.social\""

#: src/pages/hashtag.jsx:490
#: src/pages/public.jsx:143
#: src/pages/trending.jsx:482
msgid "Invalid instance"
msgstr "Instancia non válida"

#: src/pages/hashtag.jsx:504
#: src/pages/public.jsx:157
#: src/pages/trending.jsx:494
msgid "Go to another instance…"
msgstr "Ver outra instancia…"

#: src/pages/hashtag.jsx:517
#: src/pages/public.jsx:170
#: src/pages/trending.jsx:505
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ir á miña instancia (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:210
msgid "Unable to fetch notifications."
msgstr "Non se obtiveron as notificacións."

#: src/pages/home.jsx:230
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nova</0> <1>Solicitude de Seguimento</1>"

#: src/pages/home.jsx:236
msgid "See all"
msgstr "Ver todo"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Resolvendo…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Non se puido resolver o URL"

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr "Nada por aquí."

#: src/pages/list.jsx:177
#: src/pages/list.jsx:281
msgid "Manage members"
msgstr "Xestionar membros"

#. placeholder {0}: account.username
#: src/pages/list.jsx:316
msgid "Remove <0>@{0}</0> from list?"
msgstr "Retirar a <0>@{0}</0> da lista?"

#: src/pages/list.jsx:362
msgid "Remove…"
msgstr "Retirar…"

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:94
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lista} other {# listas}}"

#: src/pages/lists.jsx:109
msgid "No lists yet."
msgstr "Sen listas por agora."

#: src/pages/login.jsx:110
#: src/pages/login.jsx:123
msgid "Failed to register application"
msgstr "Fallou o rexistro da aplicación"

#: src/pages/login.jsx:209
msgid "instance domain"
msgstr "dominio da instancia"

#: src/pages/login.jsx:233
msgid "e.g. “mastodon.social”"
msgstr "ex. \"mastodon.social\""

#: src/pages/login.jsx:244
msgid "Failed to log in. Please try again or try another instance."
msgstr "Erro ao acceder. Inténtao outra vez ou cambiando de instancia."

#: src/pages/login.jsx:256
msgid "Continue with {selectedInstanceText}"
msgstr "Continuar con {selectedInstanceText}"

#: src/pages/login.jsx:257
msgid "Continue"
msgstr "Continuar"

#: src/pages/login.jsx:265
msgid "Don't have an account? Create one!"
msgstr "Non tes unha conta? Crea unha!"

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr "Mencións privadas"

#: src/pages/mentions.jsx:160
msgid "Private"
msgstr "Privadas"

#: src/pages/mentions.jsx:170
msgid "No one mentioned you :("
msgstr "Ninguén te mencionou :("

#: src/pages/mentions.jsx:171
msgid "Unable to load mentions."
msgstr "Non se cargaron as mencións."

#: src/pages/notifications.jsx:104
msgid "You don't follow"
msgstr "Non estás a seguir"

#: src/pages/notifications.jsx:105
msgid "Who don't follow you"
msgstr "Que non te segue"

#: src/pages/notifications.jsx:106
msgid "With a new account"
msgstr "Cunha nova conta"

#: src/pages/notifications.jsx:107
msgid "Who unsolicitedly private mention you"
msgstr "Con mención privada non solicitada"

#: src/pages/notifications.jsx:108
msgid "Who are limited by server moderators"
msgstr "Que está limitada pola moderación do servidor"

#: src/pages/notifications.jsx:578
#: src/pages/notifications.jsx:919
msgid "Notifications settings"
msgstr "Axustes das notificacións"

#: src/pages/notifications.jsx:596
msgid "New notifications"
msgstr "Novas notificacións"

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:607
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anuncio} other {Anuncios}}"

#: src/pages/notifications.jsx:654
#: src/pages/settings.jsx:1163
msgid "Follow requests"
msgstr "Solicitudes de seguimento"

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:659
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# solicitude de seguimento} other {# solicitudes de seguimento}}"

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:714
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Notificacións filtradas de # persoa} other {Notificacións filtradas de # persoas}}"

#: src/pages/notifications.jsx:787
msgid "Only mentions"
msgstr "Só mencións"

#: src/pages/notifications.jsx:791
msgid "Today"
msgstr "Hoxe"

#: src/pages/notifications.jsx:796
msgid "You're all caught up."
msgstr "Xa estás ao día."

#: src/pages/notifications.jsx:819
msgid "Yesterday"
msgstr "Onte"

#: src/pages/notifications.jsx:867
msgid "Unable to load notifications"
msgstr "Non se cargaron as notificacións"

#: src/pages/notifications.jsx:946
msgid "Notifications settings updated"
msgstr "Actualizáronse os axustes das notificacións"

#: src/pages/notifications.jsx:954
msgid "Filter out notifications from people:"
msgstr "Filtrar as notificacións de persoas:"

#: src/pages/notifications.jsx:968
msgid "Filter"
msgstr "Filtrar"

#: src/pages/notifications.jsx:971
msgid "Ignore"
msgstr "Ignorar"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1044
msgid "Updated <0>{0}</0>"
msgstr "Acutalizado <0>{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1112
msgid "View notifications from <0>@{0}</0>"
msgstr "Ver notificacións de <0>@{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1133
msgid "Notifications from <0>@{0}</0>"
msgstr "Notificacións de <0>@{0}</0>"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1201
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "A partir de agora non se filtrarán as notificacións de @{0}."

#: src/pages/notifications.jsx:1206
msgid "Unable to accept notification request"
msgstr "Non se puido aceptar a solicitude de notificación"

#: src/pages/notifications.jsx:1211
msgid "Allow"
msgstr "Permitir"

#. placeholder {1}: request.account.username
#: src/pages/notifications.jsx:1231
msgid "Notifications from @{1} will not show up in Filtered notifications from now on."
msgstr "A partir de agora non se mostrarán as notificacións de @{1} nas Notificacións filtradas."

#: src/pages/notifications.jsx:1236
msgid "Unable to dismiss notification request"
msgstr "Non se puido desbotar a solicitude de notificación"

#: src/pages/notifications.jsx:1241
msgid "Dismiss"
msgstr "Desbotar"

#: src/pages/notifications.jsx:1256
msgid "Dismissed"
msgstr "Desbotada"

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr "Cronoloxía local ({instance})"

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr "Cronoloxía federada ({instance})"

#: src/pages/public.jsx:91
msgid "Local timeline"
msgstr "Cronoloxía local"

#: src/pages/public.jsx:91
msgid "Federated timeline"
msgstr "Cronoloxía federada"

#: src/pages/public.jsx:97
msgid "No one has posted anything yet."
msgstr "Ningén publicou nada por agora."

#: src/pages/public.jsx:124
msgid "Switch to Federated"
msgstr "Cambiar á Federada"

#: src/pages/public.jsx:131
msgid "Switch to Local"
msgstr "Cambiar á Local"

#: src/pages/search.jsx:50
msgid "Search: {q} (Posts)"
msgstr "Buscar: {q} (Publicacións)"

#: src/pages/search.jsx:53
msgid "Search: {q} (Accounts)"
msgstr "Buscar: {q} (Contas)"

#: src/pages/search.jsx:56
msgid "Search: {q} (Hashtags)"
msgstr "Buscar: {q} (Cancelos)"

#: src/pages/search.jsx:59
msgid "Search: {q}"
msgstr "Buscar: {q}"

#: src/pages/search.jsx:323
#: src/pages/search.jsx:405
msgid "Hashtags"
msgstr "Cancelos"

#: src/pages/search.jsx:355
#: src/pages/search.jsx:409
#: src/pages/search.jsx:479
msgid "See more"
msgstr "Ver máis"

#: src/pages/search.jsx:381
msgid "See more accounts"
msgstr "Ver máis contas"

#: src/pages/search.jsx:395
msgid "No accounts found."
msgstr "Non se atopan contas."

#: src/pages/search.jsx:451
msgid "See more hashtags"
msgstr "Ver máis cancelos"

#: src/pages/search.jsx:465
msgid "No hashtags found."
msgstr "Non se atopan cancelos."

#: src/pages/search.jsx:509
msgid "See more posts"
msgstr "Ver máis publicacións"

#: src/pages/search.jsx:523
msgid "No posts found."
msgstr "Non hai publicacións."

#: src/pages/search.jsx:567
msgid "Enter your search term or paste a URL above to get started."
msgstr "Escribe o que queres buscar ou pega un URL na caixa de busca."

#: src/pages/settings.jsx:83
msgid "Settings"
msgstr "Axustes"

#: src/pages/settings.jsx:92
msgid "Appearance"
msgstr "Aparencia"

#: src/pages/settings.jsx:168
msgid "Light"
msgstr "Claro"

#: src/pages/settings.jsx:179
msgid "Dark"
msgstr "Escuro"

#: src/pages/settings.jsx:192
msgid "Auto"
msgstr "Auto"

#: src/pages/settings.jsx:202
msgid "Text size"
msgstr "Tamaño da letra"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:207
#: src/pages/settings.jsx:232
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:246
msgid "Display language"
msgstr "Idioma da interface"

#: src/pages/settings.jsx:255
msgid "Volunteer translations"
msgstr "Traducida por voluntarias"

#: src/pages/settings.jsx:266
msgid "Posting"
msgstr "Ao publicar"

#: src/pages/settings.jsx:273
msgid "Default visibility"
msgstr "Visibilidade por defecto"

#: src/pages/settings.jsx:274
#: src/pages/settings.jsx:320
msgid "Synced"
msgstr "Sincronizado"

#: src/pages/settings.jsx:299
msgid "Failed to update posting privacy"
msgstr "Erro ao actualizar a privacidade ao publicar"

#: src/pages/settings.jsx:322
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronizado cos axustes do servidor da túa instancia. <0>Vai á túa instancia ({instance}) para realizar máis axustes.</0>"

#: src/pages/settings.jsx:337
msgid "Experiments"
msgstr "Experimentos"

#: src/pages/settings.jsx:350
msgid "Auto refresh timeline posts"
msgstr "Actualización automática das cronoloxías"

#: src/pages/settings.jsx:362
msgid "Boosts carousel"
msgstr "Carrusel de promocións"

#: src/pages/settings.jsx:378
msgid "Post translation"
msgstr "Tradución das publicacións"

#: src/pages/settings.jsx:389
msgid "Translate to "
msgstr "Traducir ao "

#: src/pages/settings.jsx:400
msgid "System language ({systemTargetLanguageText})"
msgstr "Idioma do sistema ({systemTargetLanguageText})"

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages.length
#: src/pages/settings.jsx:426
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, one {}=0 {Ocultar o botón \"Traducir\" para:} other {Ocultar o botón \"Traducir\" para (#):}}"

#: src/pages/settings.jsx:480
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Nota: esta ferramenta usa servizos externos para traducir, depende de <0>Lingva API</0> e <1>Lingva Translate</1>."

#: src/pages/settings.jsx:514
msgid "Auto inline translation"
msgstr "Tradución automática en liña"

#: src/pages/settings.jsx:518
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Mostra automaticamente na cronoloxía a tradución das publicacións. Só funciona para publicacións <0>curtas</0> sen aviso sobre o contido, multimedia ou enquisa."

#: src/pages/settings.jsx:538
msgid "GIF Picker for composer"
msgstr "Selector de GIF para o editor"

#: src/pages/settings.jsx:542
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: Esta ferramenta usa un servizo externo para buscar GIF, proporcionado por <0>GIPHY</0>. G-rated (axeitado para todas as idades), quítanse todos os parámetros de seguimento, omítese na solicitude a información da orixe da mesma, pero os termos da consulta e o enderezo IP acadan igualmente o seu servidor."

#: src/pages/settings.jsx:571
msgid "Image description generator"
msgstr "Xerador da descrición de imaxes"

#: src/pages/settings.jsx:576
msgid "Only for new images while composing new posts."
msgstr "Só para novas imaxes ao redactar novas publicacións."

#: src/pages/settings.jsx:583
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: esta ferramenta usa un servizo de IA externo, proporcionado por <0>img-alt-api</0>. Pode que non funcione moi ben. Só para imaxes e en Inglés."

#: src/pages/settings.jsx:609
msgid "Server-side grouped notifications"
msgstr "Notificacións agrupadas polo servidor"

#: src/pages/settings.jsx:613
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Característica en fase Alpha. Mellora potencial no agrupamento cunha lóxica básica para agrupar."

#: src/pages/settings.jsx:634
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Importar/exportar na \"Nube\" os axustes dos atallos"

#: src/pages/settings.jsx:639
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Moi experimental.<0/>Gárdase nas notas do teu propio perfil. As notasdo perfil (privadas) normalmente úsanse para outras contas e están ocultas no teu perfil."

#: src/pages/settings.jsx:650
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: Esta ferramenta usa a API do servidor da instancia con sesión iniciada actualmente."

#: src/pages/settings.jsx:667
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Modo Capa <0>(<1>Texto</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:676
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Substitúe texto por bloques, útil para facer capturas de pantalla, por privacidade."

#: src/pages/settings.jsx:701
msgid "About"
msgstr "Sobre"

#: src/pages/settings.jsx:740
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Creado</0> por <1>@cheeaun</1>"

#: src/pages/settings.jsx:769
msgid "Sponsor"
msgstr "Patrocinios"

#: src/pages/settings.jsx:777
msgid "Donate"
msgstr "Doar"

#: src/pages/settings.jsx:793
msgid "Privacy Policy"
msgstr "Política de Privacidade"

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:800
msgid "<0>Site:</0> {0}"
msgstr "<0>Web:</0> {0}"

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener noreferrer" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:807
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versión:</0> <1/> {0}"

#: src/pages/settings.jsx:822
msgid "Version string copied"
msgstr "Copiouse o número de versión"

#: src/pages/settings.jsx:825
msgid "Unable to copy version string"
msgstr "Non se copiou a cadea coa versión"

#: src/pages/settings.jsx:1060
#: src/pages/settings.jsx:1065
msgid "Failed to update subscription. Please try again."
msgstr "Fallou a actualización da subscrición. Inténtao outra vez."

#: src/pages/settings.jsx:1071
msgid "Failed to remove subscription. Please try again."
msgstr "Fallou a retirada da subscrición. Inténtao outra vez."

#: src/pages/settings.jsx:1078
msgid "Push Notifications (beta)"
msgstr "Notificacións Push (beta)"

#: src/pages/settings.jsx:1100
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "As notificacións Push están bloqueadas. Actívaas nos axustes do teu navegador."

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1109
msgid "Allow from <0>{0}</0>"
msgstr "Permitir de <0>{0}</0>"

#: src/pages/settings.jsx:1118
msgid "anyone"
msgstr "calquera"

#: src/pages/settings.jsx:1122
msgid "people I follow"
msgstr "persoas que sigo"

#: src/pages/settings.jsx:1126
msgid "followers"
msgstr "seguidoras"

#: src/pages/settings.jsx:1159
msgid "Follows"
msgstr "Segue"

#: src/pages/settings.jsx:1167
msgid "Polls"
msgstr "Enquisas"

#: src/pages/settings.jsx:1171
msgid "Post edits"
msgstr "Edicións de publicacións"

#: src/pages/settings.jsx:1192
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Non se concedeu o permiso para Push desde o último acceso. Terás que <0><1>acceder</1> outra vez para conceder o permiso</0>."

#: src/pages/settings.jsx:1208
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTA: As notificacións Push só funcionan para <0>unha conta</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:599
#: src/pages/status.jsx:1133
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:824
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Non iniciaches sesión. Non é posible interactuar (responder, promover, etc)."

#: src/pages/status.jsx:844
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Esta publicación procede de outra instancia (<0>{instance}</0>). Non é posible interaccionar (responder, promover, etc)."

#: src/pages/status.jsx:872
msgid "Error: {e}"
msgstr "Erro: {e}"

#: src/pages/status.jsx:879
msgid "Switch to my instance to enable interactions"
msgstr "Cambiar á miña instancia para poder interactuar"

#: src/pages/status.jsx:981
msgid "Unable to load replies."
msgstr "Non se puideron cargar as respostas."

#: src/pages/status.jsx:1093
msgid "Back"
msgstr "Atrás"

#: src/pages/status.jsx:1124
msgid "Go to main post"
msgstr "Ir á publicación principal"

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1147
msgid "{0} posts above ‒ Go to top"
msgstr "{0} publicacións máis arriba ― Ir arriba"

#: src/pages/status.jsx:1190
#: src/pages/status.jsx:1253
msgid "Switch to Side Peek view"
msgstr "Cambiar a Vista Lateral con detalle"

#: src/pages/status.jsx:1254
msgid "Switch to Full view"
msgstr "Cambiar a Vista completa"

#: src/pages/status.jsx:1272
msgid "Show all sensitive content"
msgstr "Mostrar todo o contido sensible"

#: src/pages/status.jsx:1277
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1286
msgid "Unable to switch"
msgstr "Non se puido cambiar"

#. placeholder {1}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1293
msgid "Switch to post's instance ({1})"
msgstr "Cambiar á instancia ({1}) da publicación"

#: src/pages/status.jsx:1296
msgid "Switch to post's instance"
msgstr "Cambiar á instancia da publicación"

#: src/pages/status.jsx:1354
msgid "Unable to load post"
msgstr "Non se puido cargar a publicación"

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1490
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# resposta} other {<0>{1}</0> respostas}}"

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1508
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comentario} other {<0>{0}</0> comentarios}}"

#: src/pages/status.jsx:1530
msgid "View post with its replies"
msgstr "Ver publicación coas suas respostas"

#: src/pages/trending.jsx:72
msgid "Trending ({instance})"
msgstr "En voga en ({instance})"

#: src/pages/trending.jsx:229
msgid "Trending News"
msgstr "Novas populares"

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener noreferrer" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:348
msgid "By {0}"
msgstr "Por {0}"

#: src/pages/trending.jsx:409
msgid "Back to showing trending posts"
msgstr "Volver a mostrar publicacións populares"

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:414
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "A mostrar publicacións que mencionan <0>{0}</0>"

#: src/pages/trending.jsx:426
msgid "Trending posts"
msgstr "Publicacións populares"

#: src/pages/trending.jsx:449
msgid "No trending posts."
msgstr "Sen publicacións en voga."

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Un cliente web minimalista para Mastodon que fai as cousas ao seu xeito."

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr "Accede con Mastodon"

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr "Crear conta"

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Conecta a túa conta Mastodon/Fediverso. <0/>As credenciais non se gardan neste servidor."

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Creado</0> por <1>@cheeaun</1>. <2>Política de Privacidade</2>."

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr "Captura de pantalla do Carrusel de Promocións"

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr "Carrusel de Promocións"

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separa visualmente as publicacións orixinais daquelas que foron compartidas (publicacións promovidas)."

#: src/pages/welcome.jsx:142
msgid "Screenshot of nested comments thread"
msgstr "Captura de pantalla dos comentarios agrupados do fío"

#: src/pages/welcome.jsx:146
msgid "Nested comments thread"
msgstr "Fío cos comentarios agrupados"

#: src/pages/welcome.jsx:149
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Sigue as conversas fácilmente. Respostas semicontraídas."

#: src/pages/welcome.jsx:157
msgid "Screenshot of grouped notifications"
msgstr "Captura de pantalla das notificacións agrupadas"

#: src/pages/welcome.jsx:161
msgid "Grouped notifications"
msgstr "Notificacións agrupadas"

#: src/pages/welcome.jsx:164
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "As notificacións que se parecen agrúpanse e contráense para reducir o barullo."

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr "Captura de pantalla da interface con varias columnas"

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr "Unha ou Varias columnas"

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Para quen busca tranquilidade, por defecto só temos unha columna. Se o precisas podes engadir varias."

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Captura de pantalla dunha cronoloxía con varios cancelos co formulario para engadir máis cancelos"

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr "Cronoloxía con varios cancelos"

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Podes combinar ata 5 cancelos na mesma cronoloxía."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Semella que o teu navegador está a bloquear xanelas emerxentes."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Actualmente hai un borrador minimizado. Publícao ou desbótao antes de crear un novo."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Actualmente hai unha publicación aberta. Publícaa ou desbótaa antes de crear unha nova."

